/** First and last initial of a name, for an avatar with no photo. */
const initials = (fullName) => {
    const words = String(fullName || '').trim().split(/\s+/).filter(Boolean);
    if (!words.length) {
        return '';
    }
    return (words[0][0] + (words.length > 1 ? words[words.length - 1][0] : '')).toUpperCase();
};

export default initials;
